import { render, staticRenderFns } from "./MedicationInstructionForm.vue?vue&type=template&id=feaef3b0&scoped=true&"
import script from "./MedicationInstructionForm.vue?vue&type=script&lang=ts&"
export * from "./MedicationInstructionForm.vue?vue&type=script&lang=ts&"
import style0 from "./MedicationInstructionForm.vue?vue&type=style&index=0&id=feaef3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaef3b0",
  null
  
)

export default component.exports